<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <span class="brand-mark" aria-hidden="true">F</span>
      <span class="brand-text">fidmarket</span>
    </div>

    <div class="navbar-links">
      <router-link to="/dashboard">
        <span class="nav-icon icon-dashboard" aria-hidden="true"></span>
        <span class="nav-label">Dashboard</span>
      </router-link>
      <router-link to="/scanner">
        <span class="nav-icon icon-sales" aria-hidden="true"></span>
        <span class="nav-label">Ventes</span>
      </router-link>
      <router-link to="/stats">
        <span class="nav-icon icon-stats" aria-hidden="true"></span>
        <span class="nav-label">Stats</span>
      </router-link>
      <router-link to="/historique">
        <span class="nav-icon icon-tickets" aria-hidden="true"></span>
        <span class="nav-label">Tickets</span>
      </router-link>
      <router-link to="/planning">
        <span class="nav-icon icon-planning" aria-hidden="true"></span>
        <span class="nav-label">Planning</span>
      </router-link>
      <router-link to="/previsions">
        <span class="nav-icon icon-previsions" aria-hidden="true"></span>
        <span class="nav-label">Prévisions</span>
      </router-link>
      <router-link to="/journees">
        <span class="nav-icon icon-days" aria-hidden="true"></span>
        <span class="nav-label">Journées</span>
      </router-link>
      <router-link to="/cloture">
        <span class="nav-icon icon-lock" aria-hidden="true"></span>
        <span class="nav-label">Clôture</span>
      </router-link>
      <router-link to="/parametres">
        <span class="nav-icon icon-settings" aria-hidden="true"></span>
        <span class="nav-label">Paramètres</span>
      </router-link>
    </div>

    <button class="btn-logout desktop-only" @click="logout">Déconnexion</button>

    <button class="hamburger" @click="menuOuvert = !menuOuvert" :class="{ open: menuOuvert }" aria-label="Menu">
      <span></span><span></span><span></span>
    </button>

    <!-- Menu mobile -->
    <div class="mobile-menu" :class="{ open: menuOuvert }">
      <router-link to="/dashboard"><span class="nav-icon icon-dashboard" aria-hidden="true"></span><span>Dashboard</span></router-link>
      <router-link to="/scanner"><span class="nav-icon icon-sales" aria-hidden="true"></span><span>Ventes</span></router-link>
      <router-link to="/stats"><span class="nav-icon icon-stats" aria-hidden="true"></span><span>Stats</span></router-link>
      <router-link to="/historique"><span class="nav-icon icon-tickets" aria-hidden="true"></span><span>Tickets</span></router-link>
      <router-link to="/planning"><span class="nav-icon icon-planning" aria-hidden="true"></span><span>Planning</span></router-link>
      <router-link to="/previsions"><span class="nav-icon icon-previsions" aria-hidden="true"></span><span>Prévisions</span></router-link>
      <router-link to="/journees"><span class="nav-icon icon-days" aria-hidden="true"></span><span>Journées</span></router-link>
      <router-link to="/cloture"><span class="nav-icon icon-lock" aria-hidden="true"></span><span>Clôture</span></router-link>
      <router-link to="/parametres"><span class="nav-icon icon-settings" aria-hidden="true"></span><span>Paramètres</span></router-link>
      <button class="btn-logout-mobile" @click="logout">
        <span class="nav-icon icon-logout" aria-hidden="true"></span>
        <span>Déconnexion</span>
      </button>
    </div>
  </nav>

  <!-- Bottom nav mobile (masquée pendant la saisie et sur écran bas) -->
  <nav class="bottom-nav" :class="{ 'bottom-nav--masquee': saisieActive }">
    <router-link to="/dashboard" class="bn-item">
      <span class="nav-icon icon-dashboard" aria-hidden="true"></span>
      <span class="bn-label">Dashboard</span>
    </router-link>
    <router-link to="/scanner" class="bn-item">
      <span class="nav-icon icon-sales" aria-hidden="true"></span>
      <span class="bn-label">Ventes</span>
    </router-link>
    <router-link to="/stats" class="bn-item">
      <span class="nav-icon icon-stats" aria-hidden="true"></span>
      <span class="bn-label">Stats</span>
    </router-link>
    <router-link to="/historique" class="bn-item">
      <span class="nav-icon icon-tickets" aria-hidden="true"></span>
      <span class="bn-label">Tickets</span>
    </router-link>
    <button class="bn-item bn-more" @click="menuOuvert = !menuOuvert">
      <span class="nav-icon icon-more" aria-hidden="true"></span>
      <span class="bn-label">Plus</span>
    </button>
  </nav>

  <OfflineIndicator />
  <div class="overlay" v-if="menuOuvert" @click="menuOuvert = false"></div>
</template>

<script>
import OfflineIndicator from './OfflineIndicator.vue'

const TYPES_SAISIE = ['text', 'search', 'tel', 'number', 'email', 'url', 'password']

function estChampSaisie(el) {
  if (!el) return false
  if (el.tagName === 'TEXTAREA' || el.isContentEditable) return true
  return el.tagName === 'INPUT' && TYPES_SAISIE.includes(el.type)
}

export default {
  name: 'NavBar',
  components: { OfflineIndicator },
  data() { return { menuOuvert: false, saisieActive: false } },
  mounted() {
    document.body.classList.add('merchant-layout')
    document.addEventListener('focusin', this.majSaisie)
    document.addEventListener('focusout', this.majSaisie)
  },
  unmounted() {
    document.body.classList.remove('merchant-layout')
    document.removeEventListener('focusin', this.majSaisie)
    document.removeEventListener('focusout', this.majSaisie)
  },
  watch: { $route() { this.menuOuvert = false } },
  methods: {
    majSaisie(e) {
      // focusout : le champ qui reçoit le focus est dans relatedTarget
      this.saisieActive = estChampSaisie(e.type === 'focusin' ? e.target : e.relatedTarget)
    },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('commercant')
      localStorage.removeItem('marche_ville_active')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 18px;
  background: linear-gradient(180deg, #0D1B3D 0%, #102452 100%);
  color: white;
  padding: 20px 14px;
  width: 248px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  border-right: 1px solid rgba(255,255,255,0.08);
  box-shadow: 18px 0 45px rgba(13, 27, 61, 0.13);
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 11px;
  min-height: 42px;
  padding: 0 8px 10px;
  font-size: 18px;
  font-weight: 800;
  white-space: nowrap;
  letter-spacing: 0;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

.brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: #FFFFFF;
  color: #0D1B3D;
  font-size: 17px;
  font-weight: 800;
  box-shadow: 0 10px 28px rgba(0,0,0,0.16);
}
.brand-text { line-height: 1; }

.navbar-links {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: stretch;
  min-height: 0;
  overflow-y: auto;
  padding-right: 2px;
}

.navbar-links a {
  position: relative;
  color: rgba(255,255,255,0.72);
  text-decoration: none;
  padding: 12px 12px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 650;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-height: 46px;
  touch-action: manipulation;
}
.navbar-links a:hover,
.navbar-links a.router-link-active {
  background: rgba(255,255,255,0.11);
  color: white;
  transform: translateX(2px);
}
.navbar-links a.router-link-active::before {
  content: '';
  position: absolute;
  left: -14px;
  top: 12px;
  bottom: 12px;
  width: 3px;
  border-radius: 999px;
  background: #1E6FDC;
}

.nav-icon {
  position: relative;
  display: inline-flex;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  color: currentColor;
}

.nav-icon::before,
.nav-icon::after {
  content: '';
  position: absolute;
  box-sizing: border-box;
}

.icon-dashboard::before {
  inset: 2px;
  border: 2px solid currentColor;
  border-radius: 5px;
}
.icon-dashboard::after {
  left: 6px;
  right: 6px;
  bottom: 5px;
  height: 7px;
  border-left: 2px solid currentColor;
  border-right: 2px solid currentColor;
}

.icon-sales::before {
  inset: 3px 5px;
  border: 2px solid currentColor;
  border-radius: 999px;
}
.icon-sales::after {
  left: 9px;
  top: 4px;
  width: 2px;
  height: 12px;
  background: currentColor;
  border-radius: 999px;
}

.icon-stats::before {
  left: 3px;
  right: 3px;
  bottom: 4px;
  height: 2px;
  background: currentColor;
  transform: rotate(-26deg);
  transform-origin: left center;
  border-radius: 999px;
}
.icon-stats::after {
  right: 3px;
  top: 3px;
  width: 7px;
  height: 7px;
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
}

.icon-tickets::before {
  inset: 2px 4px;
  border: 2px solid currentColor;
  border-radius: 4px;
}
.icon-tickets::after {
  left: 7px;
  right: 7px;
  top: 7px;
  height: 7px;
  border-top: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
}

.icon-planning::before,
.icon-days::before {
  inset: 3px;
  border: 2px solid currentColor;
  border-radius: 5px;
}
.icon-planning::after,
.icon-days::after {
  left: 5px;
  right: 5px;
  top: 8px;
  height: 2px;
  background: currentColor;
  box-shadow: 0 5px 0 currentColor;
}

.icon-previsions::before {
  left: 3px;
  right: 3px;
  bottom: 4px;
  height: 2px;
  background: currentColor;
  border-radius: 999px;
}
.icon-previsions::after {
  left: 4px;
  top: 4px;
  width: 11px;
  height: 9px;
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
  transform: skewY(-24deg) rotate(-8deg);
  transform-origin: center;
}

.icon-market::before {
  left: 2px;
  right: 2px;
  bottom: 3px;
  height: 10px;
  border: 2px solid currentColor;
  border-radius: 3px;
}
.icon-market::after {
  left: 3px;
  right: 3px;
  top: 3px;
  height: 7px;
  border: 2px solid currentColor;
  border-bottom: 0;
  border-radius: 8px 8px 0 0;
  box-shadow: inset 4px 0 0 -2px currentColor, inset -4px 0 0 -2px currentColor;
}

.icon-lock::before {
  left: 4px;
  right: 4px;
  bottom: 3px;
  height: 10px;
  border: 2px solid currentColor;
  border-radius: 4px;
}
.icon-lock::after {
  left: 7px;
  top: 2px;
  width: 7px;
  height: 9px;
  border: 2px solid currentColor;
  border-bottom: 0;
  border-radius: 999px 999px 0 0;
}

.icon-settings::before {
  inset: 4px;
  border: 2px solid currentColor;
  border-radius: 999px;
}
.icon-settings::after {
  left: 9px;
  top: 1px;
  width: 2px;
  height: 18px;
  background: currentColor;
  border-radius: 999px;
  box-shadow: 0 0 0 0 currentColor;
  transform: rotate(45deg);
}

.icon-logout::before {
  left: 3px;
  top: 4px;
  width: 9px;
  height: 12px;
  border: 2px solid currentColor;
  border-right: 0;
  border-radius: 3px 0 0 3px;
}
.icon-logout::after {
  right: 3px;
  top: 9px;
  width: 10px;
  height: 2px;
  background: currentColor;
  box-shadow: 4px -3px 0 -1px currentColor, 4px 3px 0 -1px currentColor;
}

.icon-more::before {
  left: 3px;
  right: 3px;
  top: 5px;
  height: 2px;
  background: currentColor;
  border-radius: 999px;
  box-shadow: 0 5px 0 currentColor, 0 10px 0 currentColor;
}

.nav-label { font-size: 14px; font-weight: 650; letter-spacing: 0; }

.btn-logout {
  margin-top: auto;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.12);
  color: white;
  padding: 11px 14px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
  touch-action: manipulation;
  min-height: 44px;
}
.btn-logout:hover {
  background: rgba(255,255,255,0.14);
  border-color: rgba(255,255,255,0.22);
  transform: translateY(-1px);
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 32px; height: 22px;
  background: none; border: none;
  cursor: pointer; padding: 0; z-index: 101;
  touch-action: manipulation;
}
.hamburger span {
  display: block; height: 2.5px;
  background: white; border-radius: 2px;
  transition: all 0.3s; transform-origin: center;
}
.hamburger.open span:nth-child(1) { transform: translateY(9.75px) rotate(45deg); }
.hamburger.open span:nth-child(2) { opacity: 0; }
.hamburger.open span:nth-child(3) { transform: translateY(-9.75px) rotate(-45deg); }

/* ===========================
   MENU MOBILE (hamburger)
   =========================== */
 .mobile-menu {
  display: none;
  position: fixed;
  top: 60px; left: 0; right: 0;
  background: #0D1B3D;
  flex-direction: column;
  padding: 10px 10px 18px;
  z-index: 99;
  box-shadow: 0 18px 45px rgba(13, 27, 61, 0.22);
  transform: translateY(-10px);
  opacity: 0;
  transition: all 0.25s ease;
  pointer-events: none;
  max-height: calc(100vh - 60px);
  overflow-y: auto;
}
.mobile-menu.open {
  transform: translateY(0);
  opacity: 1;
  pointer-events: all;
}

.mobile-menu a {
  color: rgba(255,255,255,0.9);
  text-decoration: none;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 650;
  border-radius: 12px;
  border-bottom: 0;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 56px;
  touch-action: manipulation;
}
.mobile-menu a:hover,
.mobile-menu a.router-link-active {
  background: rgba(255,255,255,0.1);
  color: white;
}

.btn-logout-mobile {
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 12px;
  color: rgba(255,255,255,0.65);
  padding: 14px 16px;
  font-size: 16px;
  text-align: left;
  cursor: pointer;
  width: 100%;
  min-height: 56px;
  touch-action: manipulation;
  display: flex;
  align-items: center;
  gap: 14px;
}
.btn-logout-mobile:hover { color: white; background: rgba(255,255,255,0.06); }

/* ===========================
   BOTTOM NAV MOBILE
   =========================== */
.bottom-nav {
  display: none;
  position: fixed;
  bottom: calc(10px + env(safe-area-inset-bottom));
  left: 10px; right: 10px;
  height: 66px;
  background: rgba(255,255,255,0.96);
  box-shadow: 0 18px 45px rgba(15,23,42,0.16);
  z-index: 100;
  align-items: stretch;
  border: 1px solid #E2E8F0;
  border-radius: 18px;
  overflow: hidden;
  backdrop-filter: blur(16px);
}

.bn-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: #64748B;
  text-decoration: none;
  font-size: 12px;
  font-weight: 700;
  transition: all 0.15s;
  touch-action: manipulation;
  min-width: 44px;
  cursor: pointer;
  background: none;
  border: none;
  border-left: 1px solid #E2E8F0;
  padding: 0;
}
.bn-item:first-child { border-left: none; }
.bn-item:hover,
.bn-item.router-link-active {
  color: #1E6FDC;
  background: #E8F1FD;
}
.bn-label { font-size: 12px; font-weight: 700; letter-spacing: 0; }

.bn-more { font-family: inherit; }

/* ===========================
   OVERLAY
   =========================== */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 98;
  background: rgba(0,0,0,0.35);
  touch-action: none;
}

/* ===========================
   RESPONSIVE
   =========================== */
@media (max-width: 900px) {
  .navbar {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: auto;
    height: 60px;
    position: sticky;
    left: auto;
    padding: 0 16px;
    border-right: none;
    box-shadow: 0 10px 24px rgba(13, 27, 61, 0.16);
  }

  .navbar-brand {
    min-height: 0;
    padding: 0;
    border-bottom: none;
    font-size: 17px;
  }

  .brand-mark {
    width: 32px;
    height: 32px;
    border-radius: 11px;
  }

  .navbar-links, .desktop-only { display: none; }
  .hamburger { display: flex; }
  .mobile-menu { display: flex; }
  .bottom-nav { display: flex; }

  :global(body.merchant-layout) {
    padding-left: 0;
    padding-bottom: calc(86px + env(safe-area-inset-bottom));
  }
}

.bottom-nav.bottom-nav--masquee { display: none; }

@media (max-width: 900px) and (max-height: 500px) {
  .navbar { height: 48px; }
  .mobile-menu { top: 48px; max-height: calc(100vh - 48px); }
  .bottom-nav { display: none; }

  :global(body.merchant-layout) {
    padding-bottom: 0;
  }
}

@media (min-width: 901px) {
  .bottom-nav { display: none; }
  :global(body.merchant-layout) {
    padding-left: 248px;
    padding-bottom: 0;
  }
}
</style>
